import { IconNameOptions } from "./Icon.types";
import {
	Alert,
	ArrowLeft,
	ArrowRight,
	Asterisk,
	Bolt,
	Calendar,
	CAPClean,
	Cars,
	Check,
	ChevronUp,
	ChevronDown,
	Close,
	Collapse,
	Comment,
	Customer,
	Damage,
	Delete,
	Doors,
	Error,
	Expand,
	FuelElectric,
	FuelPetrol,
	GavelOnce,
	GavelTwice,
	GavelSold,
	Grade1,
	Grade2,
	Grade3,
	Grade4,
	Grade5,
	GradeRetailReady,
	GradeUnknown,
	Hand,
	Handshake,
	History,
	Images,
	Info,
	Keys,
	LightbulbOn,
	ListNumbers,
	Logbook,
	MapMarker,
	Medal,
	Mileage,
	Minus,
	MOT,
	Owners,
	Plus,
	Pound,
	Puzzle,
	Service,
	Star,
	Success,
	Transmission,
	VAT,
	RegChange,
	Police,
	ModifiedVehicle,
	Taxi,
	ReRegistered,
	AppStore,
	ArrowDown,
	ArrowUp,
	Camera,
	Car,
	CarsAlt,
	ChevronLeft,
	ChevronRight,
	CloseCircle,
	Edit,
	Elipses,
	Filter,
	GooglePlay,
	Note,
	Palette,
	Skip,
	Twitter,
	Facebook,
	LinkedIn,
	Bag,
	Bicycle,
	Bookmark,
	Buildings,
	Chart,
	Dumbbell,
	FilterSlash,
	Heart,
	Sort,
	SteeringWheel,
	Medical,
	CanDo,
	Cooperative,
	CustomerCentric,
	Innovative,
	Integrity,
	Modest,
	Respectful,
} from "./svgs";

export const getIcon = (name: IconNameOptions, fillValue?: string) => {
	const svgProps = { viewBox: "0 0 24 24", fill: fillValue };

	switch (name) {
		case "alert":
			return <Alert {...svgProps} />;
		case "arrow-left":
			return <ArrowLeft {...svgProps} />;
		case "arrow-right":
			return <ArrowRight {...svgProps} />;
		case "asterisk":
			return <Asterisk {...svgProps} />;
		case "bolt":
			return <Bolt {...svgProps} />;
		case "cars":
			return <Cars {...svgProps} />;
		case "can-do":
			return <CanDo {...svgProps} />;
		case "check":
			return <Check {...svgProps} />;
		case "chevron-up":
			return <ChevronUp {...svgProps} />;
		case "chevron-down":
			return <ChevronDown {...svgProps} />;
		case "close":
			return <Close {...svgProps} />;
		case "collapse":
			return <Collapse {...svgProps} />;
		case "comment":
			return <Comment {...svgProps} />;
		case "cooperative":
			return <Cooperative {...svgProps} />;
		case "customer-centric":
			return <CustomerCentric {...svgProps} />;
		case "customer":
			return <Customer {...svgProps} />;
		case "damage":
			return <Damage {...svgProps} />;
		case "delete":
			return <Delete {...svgProps} />;
		case "error":
			return <Error {...svgProps} />;
		case "expand":
			return <Expand {...svgProps} />;
		case "gavel-going-once":
			return <GavelOnce {...svgProps} />;
		case "gavel-going-twice":
			return <GavelTwice {...svgProps} />;
		case "gavel-sold":
			return <GavelSold {...svgProps} />;
		case "hand":
			return <Hand {...svgProps} />;
		case "handshake":
			return <Handshake {...svgProps} />;
		case "images":
			return <Images {...svgProps} />;
		case "info":
			return <Info {...svgProps} />;
		case "innovative":
			return <Innovative {...svgProps} />;
		case "integrity":
			return <Integrity {...svgProps} />;
		case "lightbulb-on":
			return <LightbulbOn {...svgProps} />;
		case "list-numbers":
			return <ListNumbers {...svgProps} />;
		case "map-marker":
			return <MapMarker {...svgProps} />;
		case "medal":
			return <Medal {...svgProps} />;
		case "minus":
			return <Minus {...svgProps} />;
		case "modest":
			return <Modest {...svgProps} />;
		case "plus":
			return <Plus {...svgProps} />;
		case "pound":
			return <Pound {...svgProps} />;
		case "puzzle":
			return <Puzzle {...svgProps} />;
		case "star":
			return <Star {...svgProps} />;
		case "success":
			return <Success {...svgProps} />;
		case "calendar":
			return <Calendar {...svgProps} />;
		case "cap-clean":
			return <CAPClean {...svgProps} />;
		case "doors":
			return <Doors {...svgProps} />;
		case "fuel-electric":
			return <FuelElectric {...svgProps} />;
		case "fuel-petrol":
			return <FuelPetrol {...svgProps} />;
		case "grade-1":
			return <Grade1 {...svgProps} />;
		case "grade-2":
			return <Grade2 {...svgProps} />;
		case "grade-3":
			return <Grade3 {...svgProps} />;
		case "grade-4":
			return <Grade4 {...svgProps} />;
		case "grade-5":
			return <Grade5 {...svgProps} />;
		case "grade-retail-ready":
			return <GradeRetailReady {...svgProps} />;
		case "grade-unknown":
			return <GradeUnknown {...svgProps} />;
		case "history":
			return <History {...svgProps} />;
		case "keys":
			return <Keys {...svgProps} />;
		case "logbook":
			return <Logbook {...svgProps} />;
		case "mileage":
			return <Mileage {...svgProps} />;
		case "mot":
			return <MOT {...svgProps} />;
		case "owners":
			return <Owners {...svgProps} />;
		case "service":
			return <Service {...svgProps} />;
		case "transmission":
			return <Transmission {...svgProps} />;
		case "vat":
			return <VAT {...svgProps} />;
		case "police":
			return <Police {...svgProps} />;
		case "reg-change":
			return <RegChange {...svgProps} />;
		case "modified-vehicle":
			return <ModifiedVehicle {...svgProps} />;
		case "taxi":
			return <Taxi {...svgProps} />;
		case "reregistered":
			return <ReRegistered {...svgProps} />;
		case "respectful":
			return <Respectful {...svgProps} />;
		case "app-store":
			return <AppStore {...svgProps} />;
		case "arrow-down":
			return <ArrowDown {...svgProps} />;
		case "arrow-up":
			return <ArrowUp {...svgProps} />;
		case "camera":
			return <Camera {...svgProps} />;
		case "car":
			return <Car {...svgProps} />;
		case "cars-alt":
			return <CarsAlt {...svgProps} />;
		case "chevron-left":
			return <ChevronLeft {...svgProps} />;
		case "chevron-right":
			return <ChevronRight {...svgProps} />;
		case "close-circle":
			return <CloseCircle {...svgProps} />;
		case "edit":
			return <Edit {...svgProps} />;
		case "elipses":
			return <Elipses {...svgProps} />;
		case "filter":
			return <Filter {...svgProps} />;
		case "google-play":
			return <GooglePlay {...svgProps} />;
		case "note":
			return <Note {...svgProps} />;
		case "palette":
			return <Palette {...svgProps} />;
		case "skip":
			return <Skip {...svgProps} />;
		case "twitter":
			return <Twitter {...svgProps} />;
		case "facebook":
			return <Facebook {...svgProps} />;
		case "linkedin":
			return <LinkedIn {...svgProps} />;
		case "bag":
			return <Bag {...svgProps} />;
		case "bicycle":
			return <Bicycle {...svgProps} />;
		case "bookmark":
			return <Bookmark {...svgProps} />;
		case "buildings":
			return <Buildings {...svgProps} />;
		case "chart":
			return <Chart {...svgProps} />;
		case "dumbbell":
			return <Dumbbell {...svgProps} />;
		case "filter-slash":
			return <FilterSlash {...svgProps} />;
		case "heart":
			return <Heart {...svgProps} />;
		case "sort":
			return <Sort {...svgProps} />;
		case "steering-wheel":
			return <SteeringWheel {...svgProps} />;
		case "medical":
			return <Medical {...svgProps} />;
		default:
			return null;
	}
};
